export default "__VITE_ASSET__C6mwrdEe__"